import React, { useRef, useState, useEffect } from 'react'
import { StyleProp, StyleSheet, TextInput, TextInputProps, View, ViewStyle } from 'react-native'
import { useTheme } from '@react-navigation/native'
import { Theme } from '@theme'
import { useLanguage } from '../../context/LanguageContext'
import { Icon } from '../atoms'

interface SearchBarProps extends TextInputProps {
  containerStyle?: StyleProp<ViewStyle>,
  hasMaxWidth?: boolean
}

export const SearchBar = ({ containerStyle, hasMaxWidth, ...props }: SearchBarProps): React.ReactElement => {
  const { t } = useLanguage()

  const theme = useTheme()
  const styles = getStyle(theme)

  const textInputRef = useRef<TextInput>(null)

  const [inputValue, setInputValue] = useState(props.value || '')

  // Synchroniser le state interne avec la prop value
  useEffect(() => {
    setInputValue(props.value || '')
  }, [props.value])

  const onClear = () => {
    textInputRef.current?.clear()
    setInputValue('')
    props.onChangeText?.('')
  }

  const onChangeText = (text: string) => {
    setInputValue(text)
    props.onChangeText?.(text)
  }

  return (
    <View style={[styles.container, containerStyle, hasMaxWidth && styles.maxWidth]}>
      <Icon name="search" color={theme.colors.lightGrey} size={theme.iconSize.small} />
      <TextInput
        {...props}
        ref={textInputRef}
        autoFocus={props.autoFocus}
        value={inputValue}
        onChangeText={onChangeText}
        returnKeyType="search"
        placeholderTextColor={theme.colors.lightGrey}
        placeholder={t('search.placeholder')}
        autoCorrect={false}
        style={[styles.input, props.style]}
      />
      {!!inputValue && <Icon name="cross" color={theme.colors.lightGrey} onPress={onClear} />}
    </View>
  )
}

const getStyle = (theme: Theme) =>
  StyleSheet.create({
    container: {
      flexDirection: 'row',
      alignItems: 'center',
      paddingHorizontal: theme.spacing.sm,
      borderRadius: theme.border.jumbo * 2,
      borderWidth: 1,
      borderColor: theme.colors.lightGrey,
    },
    maxWidth: {
      maxWidth: 400,
    },
    input: {
      flex: 1,
      minWidth: 0,
      paddingLeft: theme.spacing.md,
      paddingRight: theme.spacing.md,
      paddingVertical: theme.spacing.sm,
      fontSize: theme.fontSize.medium,
      color: theme.colors.primary,
      textAlign: 'left',
    },
  })
